import { InitialValues } from 'forms/types';

import { HealthBasicsFormValues } from '../form/types';
import { HealthBasicsQuery } from '../graphql/HealthBasics';

const buildInitialValues = (data?: HealthBasicsQuery): InitialValues<HealthBasicsFormValues> => {
  const healthBasics = data?.healthBasics;

  return {
    heightInInches: healthBasics?.heightInInches,
    weight: healthBasics?.weight,
    historyOfTobaccoUse: healthBasics?.historyOfTobaccoUse,
    usedInPastYear: healthBasics?.usedInPastYear,
    planningToBeOrPregnant: healthBasics?.planningToBeOrPregnant,
    suspendedConviction: healthBasics?.suspendedConviction,
    dwiConviction: healthBasics?.dwiConviction,
    asthma: healthBasics?.asthma,
    backProblems: healthBasics?.backProblems,
    basalCellSkinCancer: healthBasics?.basalCellSkinCancer,
    cancer: healthBasics?.cancer,
    carpalTunnel: healthBasics?.carpalTunnel,
    copd: healthBasics?.copd,
    depression: healthBasics?.depression,
    diabetes: healthBasics?.diabetes,
    emphysema: healthBasics?.emphysema,
    epilepsy: healthBasics?.epilepsy,
    glaucoma: healthBasics?.glaucoma,
    headachesOrMigraines: healthBasics?.headachesOrMigraines,
    heartDisease: healthBasics?.heartDisease,
    highBloodPressure: healthBasics?.highBloodPressure,
    highCholesterol: healthBasics?.highCholesterol,
    kidneyOrLiverDisease: healthBasics?.kidneyOrLiverDisease,
    kneeInjuryOrSurgery: healthBasics?.kneeInjuryOrSurgery,
    mentalIllness: healthBasics?.mentalIllness,
    otherSeriousMedicalConditions: healthBasics?.otherSeriousMedicalConditions,
    rheumatoidArthritis: healthBasics?.rheumatoidArthritis,
    sleepApnea: healthBasics?.sleepApnea,
    stroke: healthBasics?.stroke,
    ulcerativeColitisOrIleitis: healthBasics?.ulcerativeColitisOrIleitis,
    vascularDisease: healthBasics?.vascularDisease,
    multipleSclerosis: healthBasics?.multipleSclerosis,
    alzheimerDisease: healthBasics?.alzheimerDisease,
    otherHealthIssues: healthBasics?.otherHealthIssues,
  };
};

export default buildInitialValues;
